import { type JanusCtx, type Row, ec, ecId, ecLean } from './context.js';
import { type JanusInput } from './janus.js';
import { aboveCap, capValue } from '../resources/resource-adjust.js';
import { isEncounterIdentity } from '../encounter-identity.js';

/** Food/drink post-effects share the sheet resource tools' cap, then floor at zero. */
export function applyChangeHungerThirst(ctx: JanusCtx, _input: JanusInput, ability: Row, _caster: Row, target: Row): void {
  if (!ecId(target) || !isEncounterIdentity(ecLean(target, 'encounter_id'))) return;
  for (const [layer, column, maximum] of [
    ['change_hunger', 'hunger_meter_current', 'hunger_meter_max'],
    ['change_thirst', 'thirst_meter_current', 'thirst_meter_max'],
  ] as const) {
    const delta = Number.parseInt(String(ctx.read.value(ability, layer) ?? ''), 10);
    if (!Number.isFinite(delta) || delta === 0) continue;
    // An anchored lean omission is stored zero; an explicitly unheld meter stays untouched.
    const current = ecLean(target, column);
    if (current == null) continue;
    let next = Number(current) + delta;
    const cap = ctx.read.value(target, maximum);
    if (aboveCap(next, cap)) next = capValue(cap);
    ec(target)[column] = Math.max(0, next);
  }
}
